module.exports = __webpack_public_path__ + "static/img/19b.0755fff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/19b.jpg
// module id = Kcde
// module chunks = 0